import { render, staticRenderFns } from "./DownloadHeNan.vue?vue&type=template&id=5970e316&scoped=true&"
import script from "./DownloadHeNan.vue?vue&type=script&lang=js&"
export * from "./DownloadHeNan.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.10.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5970e316",
  null
  
)

export default component.exports